import {
  INITIALIZATION_ERROR,
  type NavActions,
  NAVIGATION,
  type NavState,
} from './types';

const initialState: NavState = {
  location: '',
  previousLocation: '',
  query: {},
  queryString: '',
};

export const navReducer = (
  state = initialState,
  action: NavActions,
): NavState => {
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        previousLocation: state.location,
        location:
          action.context.canonicalPath
            .split('?')[0]
            ?.replace(/\/$/, '')
            .toLowerCase() ?? '',
        query: action.context.query ?? state.query,
      };
    case INITIALIZATION_ERROR:
      return {
        ...state,
        initErrorStatus: action.initErrorStatus,
        queryString: action.queryString ?? '',
      };
    default:
      return state;
  }
};
